import { Paragraph } from '@zillow/constellation-10';

const VerificationFailedPage = (): JSX.Element | null => {
  return (
    <>
      <Paragraph textStyle="body-lg-bold">We could not create your payment.</Paragraph>
      <Paragraph>
        We were currently unable to create your payment request. Contact our support team if you have more questions.
      </Paragraph>
    </>
  );
};

export default VerificationFailedPage;
